/**
 * A Lot is a named/numbered group of horses that go out to train together at
 * the same time — the column axis of the Training Scheduler matrix
 * (`docs/products/stable.md` "Training Scheduler", `COMPANY.md` "Lot").
 * Every Stable starts with {@link DEFAULT_LOT_COUNT} Lots; a Trainer can add
 * more, but the domain never removes one (removal is not requested by the
 * spec, so it is out of scope for this phase).
 */
export const DEFAULT_LOT_COUNT = 4;
export const LOT_NAME_MAX_LENGTH = 60;
/** Default display name for a freshly seeded or added Lot, before a Trainer
 * renames it — "Lot 1", "Lot 2", etc. */
export function defaultLotName(position) {
    return `Lot ${position}`;
}
